<template>
    <LayoutBase>
        <div v-if="loading" class="loading">
            <Spinner :height="40" :width="40"/>
        </div>
        <div v-else-if="error" class="error">
            <p>Error loading sector tree.</p>
        </div>
        <ul v-else-if="tree.length">
            <sector-node v-for="sector in tree" :key="sector.id" :sector="sector" />
        </ul>
    </LayoutBase>
</template>

<script>
import API from '@api';
import LayoutBase from '@layouts/LayoutBase.vue';
import Spinner from '@components/Spinner';
import SectorNode from '@components/SectorNode/SectorNode.vue';

export default {
    name: 'SectorTree',
    components: {
        LayoutBase,
        Spinner,
        SectorNode
    },
    data() {
        return {
            tree: [],
            loading: false,
            error: false
        };
    },
    created() {
        this.getSectorTree();
    },
    methods: {
        async getSectorTree() {
            this.loading = true;
            this.error = false;
            try {
                this.tree = await API.getSectorTree();
            } catch (err) {
                this.tree = [];
                this.error = true;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
